import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CreditmemoService } from 'src/app/services/creditmemo/creditmemo.service';
import { Creditmemoheader } from 'src/app/model/creditmemoheader.model';

@Component({
  selector: 'app-creditmemolines',
  templateUrl: './creditmemolines.component.html',
  styleUrls: ['./creditmemolines.component.css']
})
export class CreditmemolinesComponent implements OnInit {

  id: number;
  purchaseData: any;
   grnHeader: Creditmemoheader[];

  // data: GrnLine[];
  data:any;
  grandTotal : number;
  vendorGrnLine:any;

  constructor(private router: Router, private route: ActivatedRoute,
    private engineeringServices: CreditmemoService) {
    this.id = this.route.snapshot.params.id;
   
  }

  ngOnInit() {
    this.getOrderById();
  }

  getOrderById() {
    debugger;

    this.engineeringServices.GetCMLineListById(this.id).subscribe(
      (data:any) => {
        debugger;
        this.purchaseData = data;
        console.log(this.purchaseData);
        debugger;
         this.grnHeader = this.purchaseData;       
      }
    )
  }

}
